/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbServiceConfig {
    getFixupPrototypeFunction() { return ServiceNowCmdbServiceConfig.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbServiceConfig>): ServiceNowCmdbServiceConfig {
        let obj = Object.assign(new ServiceNowCmdbServiceConfig(), model);
        ServiceNowCmdbServiceConfig.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbServiceConfig>): ServiceNowCmdbServiceConfig {
        if (!model) return null;
        return ServiceNowCmdbServiceConfig.newInstance(<ServiceNowCmdbServiceConfig> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbServiceConfig) {
        if (!obj) return;

        models.ServiceNowCmdbServiceConfig.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbServiceConfig): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbServiceConfig.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rule_mapping) {
            models.ServiceNowCmdbRuleMapping.fixupPrototype(this.rule_mapping);
        }
        if (this.resource_mapping) {
            for (let val of this.resource_mapping) {
                models.ServiceNowCmdbResourceMapping.fixupPrototype(val);
            }
        }
    }

    /**
     * ServiceNow Cmdb sync resource level mapping
     */
    resource_mapping: Array<models.ServiceNowCmdbResourceMapping>;

    /**
     * ServiceNow Cmdb Sync Configuration Rule Details
     */
    rule_mapping: models.ServiceNowCmdbRuleMapping;

}
